import { css } from 'linaria';

export const faqWrapper = css`
  width: 100%;
  margin: 0 0 var(--space-500);
`;
